import { useEffect } from 'react';


export default function useKeypress(key: string, action: (event: KeyboardEvent) => void) {
  useEffect(() => {
    function onKeydown(event: KeyboardEvent) {
      if (event.key === key) {
        event.preventDefault();
        action(event);
      }
    }

    window.addEventListener('keydown', onKeydown);

    return () => window.removeEventListener('keydown', onKeydown);
  }, [action, key]);
}
